import { gql } from '@apollo/client'

const UPDATE_GOAL = gql`
  mutation updateGoal($goalUpdateInfo: GoalUpdateInput!) {
    updateGoal(goalUpdateInfo: $goalUpdateInfo) {
      id
      title
      category
      owner {
        id
        firstName
        lastName
      }
      unitOfMeasurement
      target
      archivedAt
    }
  }
`

export default UPDATE_GOAL
